import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpAllErrorsListComponent from './adpAllErrorsList.component';

let adpAllErrorsListModule = angular.module('adpAllErrorsList', [
  uiRouter
])

.component('adpAllErrorsList', adpAllErrorsListComponent)

.name;

export default adpAllErrorsListModule;



// WEBPACK FOOTER //
// ./src/app/components/adpAllErrorsList/adpAllErrorsList.js